
/** @jsxImportSource @emotion/react */

import useConfig from "../../../../actions/Tenants/config/configHook";

import { MetaConditionsForm } from "../Forms/ColorCodeTriggerForm";

import MetaForm from "../../../Forms/MetaForm";

export const default_display_config = {
    fruit_types: [],
    // exclude_fruit_types: [],
    layer_types: [],
    only_show_for_check_type: undefined

};


export function DisplayFilterForm({ object, setValue, attributes = ["fruit_types", "exclude_fruit_types", "layer_types", "manual_or_with_mini", "facilities", "meta_conditions"], withHeader = true }) {
    const config = useConfig();
    const fruitOptions = config.fruit_types.map((i) => ({ label: i.text, value: i.value }));
    const layerTypeOptions = config.layer_types.map((i) => ({ label: i.text, value: i.value }));
    const form = [
        withHeader && {
            type: "header",
            label: "Display Filter",
        },
        {
            label: "Show for Fruit Types",
            name: "fruit_types",
            description: "Only show this item for specific fruit types. Leave empty to ignore.",
            type: "single-select",
            return_array: true,
            options: fruitOptions,
            multi: true,
        },
        {
            label: "Hide for Fruit Types",
            name: "exclude_fruit_types",
            description: "Do not show this item for specific fruit types. Leave empty to ignore.",
            type: "single-select",
            return_array: true,
            options: fruitOptions,
            multi: true,
        },
        {
            label: "Show for Layer Types",
            name: "layer_types",
            description: "Show this item for specific layer types. Leave empty to ignore.",
            type: "single-select",
            options: layerTypeOptions,
            return_array: true,
            multi: true,
        },
        {
            label: "Show for Facilities",
            name: "facilities",
            options_name: "facility",
            description: "Show this item for specific facilities. Leave empty to ignore.",
            type: "select-managed",
            return_array: true,
            multi: true,
        },
        {
            label: "Hide for Facilities",
            name: "exclude_facilities",
            options_name: "facility",
            description: "Hide this item for specific facilities. Leave empty to ignore.",
            type: "select-managed",
            return_array: true,
            multi: true,
        },
        {
            label: "Only show for specific check",
            name: "manual_or_with_mini",
            description: "Only show for specific checks. Leave empty to ignore.",
            options: [
                {
                    value: "only_on_mini_check",
                    label: "Only on mini checks"
                },
                {
                    value: "only_on_manual_check",
                    label: "Only on manual checks"
                },
            ],
            type: "single-select",
        },
        {
            type: "element",
            name: "meta_conditions",
            el: <MetaConditionsForm
                name="meta_conditions"
                title="Meta conditions"
                description="Define meta conditions to filter on"
                fields={object?.meta_conditions || []}
                setArray={(meta_conditions) => setValue("meta_conditions", meta_conditions)} />
        }

    ];

    if (attributes) {
        console.log("Filtering form with attributes, but now shows everything!", attributes); // eslint-disable-line no-console
    }

    // const filteredForm = form.filter(Boolean).filter((i:any) => i?.type === "header" || attributes.includes(i?.name as any));

    return <div>
        <MetaForm
            meta={form}
            setValue={setValue}
            object={object}
            config={config}
        />
    </div>;
}
